const collapsedMaxHeight = {
  type: 'number',
  description: 'Causes the section the section have a maximum height by default, expandable to the full height.',
};

// NOTE: these should be moved to a factory pattern, combined with the components that render these elements

const schemaElemMetaData = {
  type: 'object',
  title: 'propertyList',
  description: 'Shows a header with the asset metadata, including a configured set of properties.',
  properties: {
    type: { type: 'string', const: 'propertyList' },
    title: { type: 'string', description: 'Title of the section.' },
    description: { type: 'string', description: 'Descriptive text at the start of the section.' },
    userCanDelete: {
      type: 'boolean',
      description: 'Determines whether or not an end user can delete the asset from the asset view page.',
    },
    userCanEdit: {
      type: 'boolean',
      description: 'Determines whether or not an end user can modify the asset from the asset view page.',
    },
    metadata: {
      type: 'object',
      properties: {
        properties: {
          type: 'array',
          description: 'Defines what asset properties are displayed',
          items: {
            type: 'object',
            properties: {
              key: { type: 'string', description: 'Identifier of the asset property.' },
              displayName: { type: 'string', description: 'Displayed name of the property.' },
              userCanEdit: {
                type: 'boolean',
                description: 'Determines whether the user can edit this specific property.',
              },
            },
            required: ['key'],
          },
        },
        displayName: {
          type: 'object',
          properties: {
            userCanEdit: {
              type: 'boolean',
              description: 'Determines whether the user can edit the asset display name.',
            },
          },
        },
        description: {
          type: 'object',
          properties: {
            userCanEdit: {
              type: 'boolean',
              description: 'Determines whether the user can edit the asset description.',
            },
          },
        },
      },
      required: ['properties'],
    },
    collapsedMaxHeight,
  },
  required: ['type', 'metadata'],
};

const schemaRelatedAssets = {
  type: 'object',
  title: 'relatedAssets',
  description: 'Shows a graphical overview of all assets that are directly related to the asset in the view.',
  properties: {
    type: { type: 'string', const: 'relatedAssets' },
    title: { type: 'string', description: 'Title of the section.' },
    collapsedMaxHeight,
  },
  required: ['type'],
};

const schemaAssetNetwork = {
  type: 'object',
  title: 'assetNetworkView',
  description:
    'Shows a directed acyclic graph overview of all assets that are directly or indirectly related to the asset in the view.',
  properties: {
    type: { type: 'string', const: 'assetNetworkView' },
    title: { type: 'string', description: 'Title of the section.' },
    scope: { type: 'string', enum: ['all'] },
    collapsedMaxHeight,
  },
  required: ['type', 'scope'],
};

const schemaAnalyticsDashboard = {
  type: 'object',
  title: 'analyticsDashboard',
  description: 'Shows a dashboard, based on a data context property of the asset.',
  properties: {
    type: { type: 'string', const: 'analyticsDashboard' },
    title: { type: 'string', description: 'Title of the section.' },
    property_key: { type: 'string', description: 'Property of the asset containing the data context.' },
    onMissingContent: {
      type: 'object',
      description: 'specify behaviour in case the data context is not available',
      properties: {
        placeholder: { type: 'string', description: 'text to show instead of the dashboard.' },
        showError: {
          type: 'boolean',
          description: 'either show an error if the data is missing or show the placeholder.',
        },
      },
    },
  },
  required: ['type', 'property_key'],
};

const schemaAssetView = {
  type: 'object',
  properties: {
    assetviewElements: {
      type: 'array',
      description: 'List of all elements that appear in the asset view. These elements are displayed sequentially.',
      items: {
        anyOf: [schemaElemMetaData, schemaRelatedAssets, schemaAssetNetwork, schemaAnalyticsDashboard],
      },
    },
  },
  required: ['assetviewElements'],
};

export default schemaAssetView;
